export default "__VITE_ASSET__BWrV18oy__ 400w, __VITE_ASSET__DwYWOlns__ 800w, __VITE_ASSET__DDPZ0TrT__ 1024w";